import useWebSocket from "react-use-websocket";
import {useContext, useEffect, useState} from "react";
import { Context } from "../index";
import { useCookies } from "react-cookie";

export const useChat = (chat_id, options = {}) => {
    const { user } = useContext(Context);
    const [token, setToken, removeToken] = useCookies(['access_token']);
    const socketUrl = `wss://backend.boost-ai.ru/ws/chats/chat/connect/${chat_id}?accessToken=${token.access_token}`;
    const { onOpen, onError, onClose } = options;
    const [allMessages, setAllMessages] = useState([]);

    const { sendMessage, sendJsonMessage, lastMessage, lastJsonMessage, readyState, getWebSocket } = useWebSocket(socketUrl, {
        onOpen: () => {
            console.log('Соединение открыто');
            if (onOpen) onOpen();
        },
        onError: (event) => {
            console.error('Ошибка сокета', event);
            if (onError) onError(event);
        },
        onClose: (event) => {
            console.log('Соединение закрыто');
            if (onClose) onClose(event);
        },
        shouldReconnect: () => true,
    });

    useEffect(() => {
        if (lastMessage) {
            const data = JSON.parse(lastMessage.data);
            if (Array.isArray(data)) {
                setAllMessages(data);
            } else {
                setAllMessages((prev) => [...prev, data]);
            }
        }
    }, [lastMessage]);


    if (!user) {
        console.error('User is not yet initialized');
        return {};
    }

    return {
        allMessages,
        sendMessage,
        sendJsonMessage,
        lastMessage,
        lastJsonMessage,
        readyState,
        getWebSocket,
    };
};